module.exports = __webpack_public_path__ + "media/mk-video.5b40b079.mp4";